const buildCategoryItems = (category, count, extension) => {
  return Array.from({ length: count }, (_, index) => {
    const order = String(index + 1).padStart(2, '0')
    return {
      id: `${category}_${order}`,
      title: `Template ${order}`,
      image: `/static/images/ai_clothes/${category}/${category}_${order}.${extension}`,
      category
    }
  })
}

const fullBodyItems = buildCategoryItems('full_body', 40, 'png')
const upperBodyItems = buildCategoryItems('upper_body', 10, 'png')
const lowerBodyItems = buildCategoryItems('lower_body', 10, 'png')
const shoesItems = buildCategoryItems('shoes', 10, 'jpg')

export default {
  auto: [
    ...fullBodyItems,
    ...upperBodyItems,
    ...lowerBodyItems,
    ...shoesItems
  ],
  full_body: fullBodyItems,
  upper_body: upperBodyItems,
  lower_body: lowerBodyItems,
  shoes: shoesItems
}



// WEBPACK FOOTER //
// ./src/constants/aiClothesCatalog.js